import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import Img from 'gatsby-image';
import firstViewDistrictImg from '../images/first-view-district.png';
import firstBusConnectImg from '../images/first-bus-connect.png';
import scantherImg from '../images/scanther.png';
import smartHomeImg from '../images/smart-home.png';

import styles from './referenceSlider.module.scss';

const ReferencesSlider = ({ images }) => {
  const settings = {
    className: styles.slider,
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
    pauseOnHover: true,
    lazyLoad: true
  };

  const titleClass = `${styles.sliderTitle} md-text-center`;

  return (
    <article className={styles.container}>
      <h2 className="md-text-center">References</h2>
      <Slider {...settings}>
        <div key="firstViewMobile">
          <Img sizes={images.firstViewParentImage.sizes} alt="FIRST VIEW TM PARENT" />
          <h6 className={titleClass}>FIRST VIEW<sup>TM</sup> PARENT</h6>
          <p className="md-caption md-text-center">FirstView<sup>TM</sup> Parent App is React Native mobile application for iOS and Android devices and it is also a React web application - resource for knowing the location of student’s bus, estimated arrival times at student’s stop and when student’s bus arrives or departs their school.</p>
        </div>
        <div key="firstViewDistrict">
          <Img sizes={images.firstViewDistrictImage.sizes} alt="FIRST VIEW TM DISTRICT" />
          <h6 className={titleClass}>FIRST VIEW<sup>TM</sup> DISTRICT</h6>
          <p className="md-caption md-text-center">FirstView<sup>TM</sup> District Dashboard centralizes critical transportation data for efficient decision making, performance improvement opportunities and increased customer service. Core features: Real Time Bus Tracking, Reporting Transparency, Custom Communications.</p>
        </div>
        <div key="firstBusConnect">
          <Img sizes={images.firstBusConnectImage.sizes} alt="FIRST BUS CONNECT" />
          <h6 className={titleClass}>FIRST BUS CONNECT</h6>
          <p className="md-caption md-text-center"> Designed specifically for First Bus employees, First Bus Connect provides access to local information and updates, best practices, policies and company news. Employees stay connected with updates and notifications directly from their manager.</p>
        </div>
        <div key="scanther">
          <Img sizes={images.scantherImage.sizes} alt="SCANTHER" />
          <h6 className={titleClass}>SCANTHER</h6>
          <p className="md-caption md-text-center">Scanther is a business software solution that creates and manages mobile sites and hybrid apps. System is built of several modules: customer frontend (real time app editing, push notifications, coupons), mobile site preview, native app generator, admin app.</p>
        </div>
        <div key="smartHome">
          <Img sizes={images.smartHomeImage.sizes} alt="SMART HOME" />
          <h6 className={titleClass}>SMART HOME</h6>
          <p className="md-caption md-text-center">Web desktop, mobile application and hardware solution for automatic control and monitoring of systems for heating, cooling, solar hot water, watering, lighting and entrance control. Developed for the purpose of energy efficiency supervision of homes.</p>
        </div>
      </Slider>
    </article>
  );
};

ReferencesSlider.propTypes = {
  images: PropTypes.object
};

export default ReferencesSlider;



// WEBPACK FOOTER //
// ./src/components/ReferencesSlider.js